export interface Structure {
  model_url: string;   // Model URL
  model_format: string;   // Model format
  binary: boolean;
}

export const PROVIDER_MAP: Record<string, string> = {
  GDM: 'Google Deepmind',
  // BFVD: 'Big Fantastic Virus Database (BFVD)',
  // ATBC: 'AllTheBacteria',
  // NTDX: 'Kinetoplastid Parasites',
};
export interface EntryData {
  modelEntityId: string;
  gene: string;
  uniprotAccession: string;
  uniprotId: string;
  uniprotDescription: string;
  taxId: number;
  organismScientificName: string;
  sequenceStart: number;
  sequenceEnd: number;
  uniprotSequence: string;
  sequence:string;
  modelCreatedDate: string;
  latestVersion: number;
  allVersions: [number];
  cifUrl: string;
  bcifUrl: string;
  pdbUrl: string;
  paeDocUrl: string;
  isUniProt: boolean;
  isUniProtReferenceProteome: boolean;
  isUniProtReviewed: boolean;
  amAnnotationsUrl: string;
  globalMetricValue: number;
  fractionPlddtVeryLow: number;
  fractionPlddtLow: number;
  fractionPlddtConfident: number;
  fractionPlddtVeryHigh: number;
  paeImageUrl: string;
  csvAMFileUrl?: string;
  amAnnotationsHg19Url?: string;
  amAnnotationsHg38Url?: string;
  sequenceVersionDate?: string;
  providerId?: string;
  toolUsed?: string;
  otherOrganismScientificNames?: any
  msaUrl?: string;
  plddtDocUrl?: string;
}

export interface ProviderData {
  providerName : string,
  toolUsed: string,
  providerUrl: string,
  feedback: string,
  license: string,
  citations: Citations[],
  copyrights: any,
  modelCreatedDate: string
}

export interface Citations {
  description: string,
  url: string,
  category: string
}
export interface PlddtData{
  fractionPlddtVeryLow: number;
  fractionPlddtLow: number;
  fractionPlddtConfident: number;
  fractionPlddtVeryHigh: number;
}

export interface SimilarStructure {
  afdbAccessions : string;
  uniprotDescriptions: string;
  speciesNames: string;
  expanded: boolean;
  targetToShow: string;
}

export interface ClusterData {
  clusterTotal: number;
  clusterMembers : SimilarStructure;
}

export class SummaryText {
  label: string; // Label for the text, e.g. 'Organism'
  text: string; // Text
  italic: boolean; // I.e. true/false
  show_long: boolean; // Show the full text, no matter how long, i.e. true/false
  source: string; // Source of the information, if external, e.g. UniProt
  source_url: string; // Link to the source of information, if external
  isTooltip?: boolean
}

export class SummaryData {
  title: string; // For example 'Q99ZW2'
  subtitle: string; // For example 'CRISPR-associated endonuclease Cas9/Csn1',
  flags: Flag[]; // Flags, for example EC number for enzymes
  text_limit: number; // Number of words displayed; additional words are collapsed by default, except of show_long is true
  texts: SummaryText[];
}

export class Flag {
  name: string; // Flag name
  color: string; // Background color of the flag
  url: string; // URL to external resource, if applicable
  tooltip: string; // Tooltip text
}

export class TedDomain {
  ted_domain_no: number;
  cath_label: string;
  nres_domain: number;
  plddt: number;
  cath_assignment_level: string;
  qscore: number;
  segments: {
    af_start: number;
    af_end: number;
    segment_id: number;
  }[];
}
